/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { CompanyDto, CompaniesListFilterParams } from '../api/companies/companiesClient.typings';
import { CompaniesAction, CompaniesActionType } from '../actions/companiesActions';
import { CompaniesListTableData } from '../../components/RegistryWidgets/Companies/CompaniesList/CompaniesListConfig';
import { getPageLimitByScreenSize } from '../../utils/utils';
import {
    defaultDisableProbability,
    defaultFromClassificationPercent,
    defaultToClassificationPercent,
} from '../../components/Filters/ActivityFiltersGroup/AiClassificationFilter';

export const defaultSearchType: keyof CompaniesListTableData = 'taxNumber';

export interface CompaniesState {
    companiesList: CompanyDto[];
    limit: number;
    afterKey: string;
    lastRequestItemsCount: number;
    filterParams: CompaniesListFilterParams;
    changedFilterParams: CompaniesListFilterParams;
    isLoading: boolean;
}

const initialState: CompaniesState = {
    companiesList: [],
    limit: getPageLimitByScreenSize(),
    afterKey: null,
    lastRequestItemsCount: null,
    filterParams: {
        search_type: defaultSearchType,
        search_text: '',
        statuses: [],
        storeTypes: [],
        taxationTypes: [],
        taxAuthorityIds: [],
        fromCashBoxesCount: null,
        toCashBoxesCount: null,
        fromStoresCount: null,
        toStoresCount: null,
        classifications: [],
        disableProbability: defaultDisableProbability,
        toClassificationPercent: defaultToClassificationPercent,
        fromClassificationPercent: defaultFromClassificationPercent,
    },
    changedFilterParams: null,
    isLoading: false,
};

function companiesReducer(state: CompaniesState = initialState, action: CompaniesAction): CompaniesState {
    switch (action.type) {
        case CompaniesActionType.OPEN_REGISTRY_COMPANIES_LIST_PAGE:
            return {
                ...state,
            };

        case CompaniesActionType.FETCH_NEXT_PAGE_START:
            return {
                ...state,
                isLoading: true,
                changedFilterParams: null,
            };

        case CompaniesActionType.APPLY_FILTERS:
            return {
                ...state,
                isLoading: true,
                companiesList: [],
                afterKey: null,
                lastRequestItemsCount: null,
                filterParams: state.changedFilterParams ? { ...state.changedFilterParams } : { ...state.filterParams },
                changedFilterParams: null,
            };

        case CompaniesActionType.CHANGE_FILTERS:
            return {
                ...state,
                changedFilterParams: action.payload,
            };

        case CompaniesActionType.FETCH_COMPANIES_LIST_SUCCESS:
            const combinedList: CompanyDto[] = [...state.companiesList];

            if (action.payload.list.companies && action.payload.list.companies.length > 0) {
                combinedList.push(...action.payload.list.companies);
            }
            return {
                ...state,
                isLoading: false,
                companiesList: combinedList,
                afterKey: action.payload.list.afterKey,
                lastRequestItemsCount: action.payload.list.companies.length,
            };

        case CompaniesActionType.FETCH_COMPANIES_LIST_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case CompaniesActionType.DOWNLOAD_EXCEL:
            return {
                ...state,
                isLoading: true,
                changedFilterParams: null,
            };

        case CompaniesActionType.DOWNLOAD_EXCEL_SUCCESS:
        case CompaniesActionType.DOWNLOAD_EXCEL_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case CompaniesActionType.EXIT_REGISTRY_COMPANIES_LIST_PAGE:
            return {
                ...state,
                changedFilterParams: null,
            };

        default:
            return state;
    }
}

export default companiesReducer;
